export default __webpack_public_path__ + "static/media/Tunic of Crimson Slaughter.4b94555c.jpg";